import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import { bindActionCreators } from "redux";
import { getEmployeesWithSize } from "../../../store/employee/actions";
import { toast } from 'react-toastify'

class ItemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backdrop: true,
      discount: 0,
      employeesFilter: "",
      employeesPage: 1,
      isOpen: true,
      name: "",
      pageSize: 10,
      price: 0.0,
      quantity: 1,
      selectedEmployee: null,
      selectedEmployees: [],
      selectedEmployeesFilter: "",
      selectedEmployeesIndex: 0,
      selectedEmployeesPage: 1,
      selectedRequiredEmployee: null,
      stock: 0,
      total: 0.0,
      unmountOnClose: true,
    };

    // Bind Here
    //
    this.setItem = this.setItem.bind(this);
    this.onChange = this.onChange.bind(this);
    this.addEmployee = this.addEmployee.bind(this);
    this.removeEmployee = this.removeEmployee.bind(this);
  }

  componentDidMount() {
    const { item } = this.props;
    this.setState({
      name: item.name,
      price: item.price
    });
    this.performGetEmployees(true);
  }

  performGetEmployees(reset = false) {
    const { employeesPage, employeesFilter, pageSize } = this.state;
    this.props.getEmployeesWithSize({
      page: employeesPage,
      employeesFilter,
      size: pageSize,
      reset
    });
  }

  componentDidUpdate(prevProps) {
    this.setItem(prevProps);
  }

  onChange(event) {
    const reg = /^(\d+\.?\d*|\.\d+)$/;
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  onAccept() {
    const { name, price, discount, total, quantity, selectedEmployees } = this.state;
    const tempEmp = JSON.stringify(selectedEmployees)
    const item = {
      name,
      price,
      discount,
      total,
      quantity,
      selectedEmployees: JSON.parse(tempEmp),
    };
    this.props.onAccept(item);
    this.setState({ quantity: 1, selectedEmployees: []})
  }

  renderSelectedEmployees() {
    const { selectedEmployees } = this.state;
    if (selectedEmployees != null) {
      const result = selectedEmployees.map(item => {
        return (
          <div className="div-employee" onDoubleClick={() => this.removeEmployee(item)} key={item.selectedEmployeesIndex}>
            {item.employee.name} {item.employee.lastname}
          </div>
        );
      });
      return result;
    }
  }

  renderEmployees() {
    const { employees } = this.props;
    if (employees != null) {
      const result = employees.map(employee => {
        return (
          <div className="div-employee" onDoubleClick={() => this.addEmployee(employee)} key={employee.id}>
            {employee.name} {employee.lastname}
          </div>
        );
      });
      return (
        <div>
          {result}
          <div>
          <Button color="primary"> Prev </Button>
            <Button color="primary"> Next </Button>
          </div>
        </div>
      );
    }
  }

  //

  setItem(prevProps) {
    const { item } = this.props;
    if (prevProps.item != item && item != null) {
      this.setState({
        name: item.name,
        price: item.price
      });
    }
  }

  addEmployee(employee){
    var { quantity, selectedEmployees, selectedEmployeesIndex } = this.state;
    if( selectedEmployees.length + 1 > quantity) { toast.warn("Límite de empleados requeridos alcanzado.")} 
    else {
      selectedEmployees.push({selectedEmployeesIndex, employee});
      selectedEmployeesIndex++;
      this.setState({selectedEmployees, selectedEmployeesIndex});
    }
  }

  removeEmployee(employee){
    const { selectedEmployees } = this.state;
    const index = selectedEmployees.indexOf(employee)
    selectedEmployees.splice(index,1);
    this.setState({selectedEmployees});
  }

  render() {
    const {
      backdrop,
      discount,
      name,
      price,
      quantity,
      selectedEmployees,
      stock,
      total,
      unmountOnClose,
    } = this.state;
    const { item, isOpen, onAccept, onCancel } = this.props;
    let newTotal = 0;
    if (discount != 0) {
      newTotal = quantity * ((price * discount) / 100);
    } else {
      newTotal = quantity * price;
    }

    return (
      <Modal
        isOpen={isOpen}
        size={"lg"}
        className="sell-item-modal"
        backdrop={backdrop}
        unmountOnClose={unmountOnClose}
      >
        <ModalHeader>Detalle</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col>
                Producto / Servicios
                <input
                  type="text"
                  className="form-control"
                  disabled={true}
                  value={name}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                Cantidad
                <input
                  type="text"
                  className="form-control text-align-center"
                  name="quantity"
                  value={quantity}
                  onChange={this.onChange}
                />
              </Col>
              <Col>
                Valor Unit.
                <input
                  value={price}
                  type="text"
                  className="form-control text-align-center"
                  name="price"
                  onChange={this.onChange}
                />
              </Col>
              <Col>
                Descuento por Item
                <input
                  value={discount}
                  type="text"
                  className="form-control text-align-center"
                  name="discount"
                  onChange={this.onChange}
                />
              </Col>
            </Row>
            <Row>
              <Col lg="5" xl="5">
                Empleados Seleccionados <b>{selectedEmployees.length}</b>. Requeridos: <b>{quantity}</b>
                <div className="div-sell-modal-employee">
                  {this.renderSelectedEmployees()}
                </div>
              </Col>
              <Col lg="2" xl="2" > 
              </Col>
              <Col lg="5" xl="5">
                Empleados de la Tienda
                <div className="div-sell-modal-employee">
                  {this.renderEmployees()}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                Total
                <input
                  type="text"
                  className="form-control text-align-center"
                  disabled={true}
                  value={newTotal.toFixed(2)}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <Button color="primary" onClick={() => this.onAccept()}> Añadir </Button>
              </Col>
              <Col>
                <Button color="primary" onClick={onCancel}> Cancelar </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>Footer</ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    employees,
    error,
    loading,
    pageSize,
    total
  } = state.employee.employeeList;

  return {
    employees,
    error,
    loading,
    pageSize,
    total
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getEmployeesWithSize
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemModal);



// WEBPACK FOOTER //
// ./src/components/RemoteSellComponents/ItemModal/ItemModal.js